import React, { useEffect, useState } from 'react';
import useStore from 'src/store/cns';
import Search from 'src/components/domain/Search';
import Register from 'src/components/domain/Register';
import { Box, Button, Container, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import Information from 'src/components/domain/Information';
import { handleError } from 'src/utils/errors/common';
import { getFirstLevelDomains } from 'src/utils/logs/domain';

const AuthStatus: React.FC = () => {
  const wallet = useStore(state => state.wallet);
  const setFirstLvlDomains = useStore(state => state.setFirstLvlDomains);

  const navigate = useNavigate();
  const location = useLocation();

  const [registerState, setRegisterState] = useState<RegisterState>({
    domainName: '',
    status: 'searching',
  });

  const showDomain = () => {
    navigate('/cns/my-domains');
  };

  useEffect(() => {
    if (location.state?.registerState) {
      setRegisterState(location.state?.registerState);
    } else {
      setRegisterState({ domainName: '', status: 'searching' });
    }

    const fetchData = async () => {
      try {
        setFirstLvlDomains(await getFirstLevelDomains());
      } catch (error) {
        handleError(error, 'Failed to query logs');
      }
    };
    fetchData();
  }, [location.state]);

  return (
    <Box
      data-cy="domain-search"
      sx={{
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        background: theme => theme.palette.background.paper,
      }}
    >
      {registerState.status === 'searching' ? (
        <Search
          setRegisterState={setRegisterState}
          domainName={registerState.domainName}
        />
      ) : registerState.status === 'information' ? (
        <Information
          setRegisterState={setRegisterState}
          domainName={registerState.domainName}
        />
      ) : registerState.status === 'registering' &&
        wallet &&
        registerState.domainName.length > 0 ? (
        <Register
          setRegisterState={setRegisterState}
          walletAddress={wallet.address}
          domainName={registerState.domainName}
        />
      ) : (
        <Container maxWidth="lg" sx={{ mt: 24 }}>
          <Box display="flex" flexDirection="column" alignItems="center">
            {registerState.status === 'success' ? (
              <>
                <Typography variant="h3" align="center" gutterBottom>
                  Congratulations
                </Typography>
                <Typography variant="h6" align="center" sx={{ mb: 4 }}>
                  You have successfully registered {registerState.domainName}
                  .cam!
                </Typography>
                <Button
                  variant="contained"
                  onClick={() => showDomain()}
                  sx={{
                    color: 'text.primary',
                    backgroundColor: 'primary.main',
                    padding: '10px 16px',
                  }}
                >
                  View Domain
                </Button>
              </>
            ) : (
              <>
                <Typography
                  variant="h3"
                  align="center"
                  gutterBottom
                  fontWeight="bold"
                >
                  Something went wrong
                </Typography>
                <Typography variant="h6" align="center" sx={{ mb: 4 }}>
                  We could not register {registerState.domainName}.cam for you
                </Typography>
                <Button
                  variant="contained"
                  onClick={() =>
                    setRegisterState({ domainName: '', status: 'searching' })
                  }
                  sx={{
                    color: 'text.primary',
                    backgroundColor: 'primary.main',
                    padding: '10px 16px',
                  }}
                >
                  Try Again
                </Button>
              </>
            )}
          </Box>
        </Container>
      )}
    </Box>
  );
};

export default AuthStatus;
